import React from 'react';
import './Posts.scss';
import Blog from '../Data/Blog.js';
import Nav from '../Nav/Nav'
import { Link, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Posts() {
  const location = useLocation()

  return (
    <div className="posts max-800" style={{height: '40vh'}}>
      <Helmet>
          <meta charSet="utf-8" />
          <meta name="description" content="Posts from Miko Gonzaga" />
          <title>Posts by Miko Gonzaga</title>
      </Helmet>

      { location.pathname === '/posts' ? <Nav /> : null }

      <div className="animate fadeIn">
        <h2>Posts</h2>

        {Blog.map(({ id, title, date }) =>
          <Link className="post" to={`/posts/${id}`} key={id}>
            <span className="title">{title}</span>
            <span className="date">{date}</span>
          </Link>
        )}
      </div>
    </div>
  )
}
